<div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="15px">

  <p class="no-margin"><b>Selecione os Status abaixo</b></p>

  <mat-form-field class="full-width">
    <mat-chip-list #chipList aria-label="Status selection">
      <mat-chip
        *ngFor="let status of statusSelection"
        [removable]="true"
        (removed)="removeStatus(status)"
        color="primary"
        selected
      >
        {{status.name}}
        <mat-icon *ngIf="!status.default" matChipRemove>cancel</mat-icon>
      </mat-chip>

      <mat-select
        [(ngModel)]="statusCurrent"
        (valueChange)="addStatusToSelection($event)"
      >
        <mat-option value="A">Abertos</mat-option>
        <mat-option value="T">Em Atendimento</mat-option>
        <mat-option value="P">Pendente</mat-option>
        <mat-option value="R">Resolvido</mat-option>
        <mat-option value="F">Fechado</mat-option>
        <mat-option value="C">Cancelado</mat-option>
      </mat-select>
    </mat-chip-list>
  </mat-form-field>

  <app-filter-call class="full-width"
    (search)="search($event)"
  ></app-filter-call>

  <app-knowledge-base-call-list  class="full-width"
    [calls]="calls"
  ></app-knowledge-base-call-list>

  <div *ngIf="isLoading" fxFill fxLayoutAlign="center center">
    <mat-spinner diameter="30"></mat-spinner>
  </div>

  <mat-paginator
    fxFill
    itemsPerPageLabel="Items por página"
    [length]="length"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="setPage = $event"
  >
  </mat-paginator>
</div>
